'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserEmailBatch } from '../../Entities/User/UserEmailBatch';
import { UserEmailBatchCollection } from '../../Collections/User/UserEmailBatchCollection';

export class UserEmailBatchRepository extends CoreRepository {
  public createUserEmailBatch(userId: number, payload: object = {}) {
    return this.webAPI.createUserEmailBatch(userId, payload).then((response) => {
      const userEmailBatch = new UserEmailBatch();
      userEmailBatch.hydrate(response);

      return userEmailBatch;
    });
  }

  public getUserEmailBatch(userId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserEmailBatch(userId, options).then((response) => {
      const collection = new UserEmailBatchCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserEmailBatch();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public removeUserEmailBatch(userId: number, batchId: number) {
    return this.webAPI.removeUserEmailBatch(userId, batchId).then((response) => {
      return response;
    });
  }
}
